import { render, staticRenderFns } from "./promotion-products-sidebar-column.vue?vue&type=template&id=988c01a6&scoped=true"
import script from "./promotion-products-sidebar-column.vue?vue&type=script&lang=js"
export * from "./promotion-products-sidebar-column.vue?vue&type=script&lang=js"
import style0 from "./promotion-products-sidebar-column.vue?vue&type=style&index=0&id=988c01a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988c01a6",
  null
  
)

export default component.exports